import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Paragraph } from '@scentregroup/ui'
import style from './index.module.scss'

const MAX_PRICE_RATING = 4

const PriceRating = ({ priceRating }) => (
  <Paragraph type="large" className={style.priceRating}>
    {[...Array(MAX_PRICE_RATING)].map((_, i) => (
      <span
        key={i}
        className={classNames(style.priceRating, {
          [style.fadedPrice]: i > priceRating,
        })}
      >
        $
      </span>
    ))}
  </Paragraph>
)

PriceRating.propTypes = {
  priceRating: PropTypes.number.isRequired,
}

export default PriceRating
